import { emptyValidator, formValidator } from "../../validators";

const negotiationFormValidationConfig = {
  jotChargeCategory: {
    validators: [emptyValidator()],
    name: "Charge Category",
  },
  jotChargeType: {
    validators: [emptyValidator()],
    name: "Charge Type",
  },
  jotChargeMode: {
    validators: [emptyValidator()],
    name: "Charge Mode",
  },
  // jotQty: {
  //   validators: [emptyValidator()],
  //   name: "Quantity",
  // },
  // jotCharge: {
  //   validators: [emptyValidator()],
  //   name: "Charge",
  // },
  jotStatus: {
    validators: [emptyValidator()],
    name: "Status",
  },
  jotActive: {
    validators: [emptyValidator()],
    name: "Active",
  },
};

const flagFormValidationConfig = {
  jfgFlagType: {
    validators: [emptyValidator()],
    name: "Flag Type",
  },
  jfgResolved: {
    validators: [emptyValidator()],
    name: "Resolved",
  },
  jfgActive: {
    validators: [emptyValidator()],
    name: "Active",
  },
};


export const negotiationFormValidation = (negotiationData) => {
  return formValidator(negotiationData, negotiationFormValidationConfig);
};

export const flagFormValidation = (flagData) => {
  return formValidator(flagData, flagFormValidationConfig);
};
